
export const SCROLL_CONSTANTS = {
  scrollTopPosition: 20,
  maxTopValue: 1,
  minTopValue: 0.9,
  maxScrollHeight: 5
};
